export interface AvatarPreset {
  id: `face-${string}`
  label: string
  src: string
}

export const AVATAR_PRESETS: AvatarPreset[] = Array.from({ length: 63 }, (_, index) => {
  const number = String(index + 1).padStart(2, "0")
  return {
    id: `face-${number}` as AvatarPreset["id"],
    label: `Avatar ${index + 1}`,
    src: `/avatars/face-${number}.png`,
  }
})

export const DEFAULT_AVATAR_SOURCE = "/avatars/default.svg"

const presetById = new Map(AVATAR_PRESETS.map((preset) => [preset.id, preset]))
const legacyPresetMap: Record<string, AvatarPreset["id"]> = {
  coral: "face-01",
  violet: "face-02",
  teal: "face-03",
  sunset: "face-04",
}

export function normalizeAvatarPresetId(value: string | undefined): AvatarPreset["id"] | "" {
  const normalized = value?.trim().toLowerCase() || ""
  const legacy = legacyPresetMap[normalized]
  if (legacy) return legacy
  return presetById.has(normalized as AvatarPreset["id"])
    ? normalized as AvatarPreset["id"]
    : ""
}

export function avatarPresetSource(value: string | undefined): string {
  const presetId = normalizeAvatarPresetId(value)
  return presetId ? presetById.get(presetId)?.src || DEFAULT_AVATAR_SOURCE : DEFAULT_AVATAR_SOURCE
}

export function AvatarFace({ presetId, className = "" }: { presetId?: string; className?: string }) {
  const normalizedPresetId = normalizeAvatarPresetId(presetId)
  const preset = normalizedPresetId ? presetById.get(normalizedPresetId) : undefined
  return (
    <img
      className={className}
      src={preset?.src || DEFAULT_AVATAR_SOURCE}
      alt={preset?.label || "Default avatar"}
      decoding="async"
    />
  )
}
